module.exports = __webpack_public_path__ + "static/media/radar-hurricane_richard_20200915.f39c2354.png";